var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08691 0C5.37967 0 4.70139 0.280951 4.2013 0.781048C3.7012 1.28115 3.42025 1.95942 3.42025 2.66667C3.42025 3.37391 3.7012 4.05219 4.2013 4.55229C4.70139 5.05238 5.37967 5.33333 6.08691 5.33333C6.79416 5.33333 7.47244 5.05238 7.97253 4.55229C8.47263 4.05219 8.75358 3.37391 8.75358 2.66667C8.75358 1.95942 8.47263 1.28115 7.97253 0.781048C7.47244 0.280951 6.79416 0 6.08691 0ZM4.37728 7.50911C2.39128 7.87645 0.0869141 8.81867 0.0869141 10.3333V12H12.0869V10.3333C12.0869 8.81867 9.78255 7.87578 7.79655 7.50911L6.08691 9.21875L4.37728 7.50911Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.c8a6c7bccbf8b592e83ab6736e677b4a.svg";
export { ForwardRef as ReactComponent };